import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Loading } from "../../../components/Loading/Loading";
import { Calendars } from "../../../components/Calendar/Calendar";
import { useHistory } from "react-router-dom";
import { dataUserSession } from "../../../utilities/dataSession";
import { Dropdown } from "primereact/dropdown";
import { FooterButtonSigle } from "../../../components/FooterButton/FooterButton";
import { DialogConfirm } from "../../../components/DialogService/DialogService";

//SERVICE
import { genGetRequestStatusList, genGetRequestTypeList } from "../../../service/GEN/GenService";

//CSS
import ValidateService from "../../../components/ValidateService/ValidateService";

export default function P108() {
    const history = useHistory();
    const toast = useRef(null);

    const [loading, setLoading] = useState(false);
    const [errData, setErrData] = useState(null);

    const [data, setData] = useState({
        inquireMode: "M",
        requestDateBegin: "",
        requestDateEnd: "",
        contractNo: "",
        requestStatus: "0",
        requestType: "",
        searchWord: "",
    });

    const [requestSrh, setRequestSrh] = useState({ userId: "" });
    const [requestStatusList, setRequestStatusList] = useState([]);
    const [requestTypeList, setRequestTypeList] = useState([]);
    const [confirmDialog, setConfirmDialog] = useState(false);
    const onInputTextChange = (e, key) => {
        const val = (e.target && e.target.value) || "";
        setData({
            ...data,
            [`${key}`]: val,
        });
    };
    const footerButtonSingle = () => {
        return (
            <FooterButtonSigle
                btnLabel="ปิด"
                onClick={() => {
                    setConfirmDialog(false);
                }}
            />
        );
    };
    const condition = () => {
        if (data.requestDateBegin !== "" || data.requestDateEnd !== "" || data.contractNo !== "" || data.requestStatus !== "0" || data.requestType !== "" || data.searchWord !== "") {
            return true;
        } else {
            return false;
        }
    };
    const onSearch100 = () => {
        // console.log('dataSrh ',data)
        if (condition()) {
            history.push({
                pathname: "/100",
                state: { dataSrh: data },
            });
        } else {
            setConfirmDialog(true);
        }
    };

    useEffect(() => {
        if (dataUserSession()) {
            if (history.location.state && history.location.state.dataSrh) {
                setData({
                    ...history.location.state.dataSrh,
                    requestDateBegin: history.location.state.dataSrh.requestDateBegin !== "" ? history.location.state.dataSrh.requestDateBegin : "",
                    requestDateEnd: history.location.state.dataSrh.requestDateEnd !== "" ? history.location.state.dataSrh.requestDateEnd : "",
                });
            }

            setRequestSrh({
                userId: dataUserSession().userId,
            });
        } else {
            history.push("/login");
        }
    }, []);

    // useEffect(() => {
    //     console.log('data ',data);
    // }, [data])

    useEffect(() => {
        onGenGetRequestStatusList();
        onGenGetRequestTypeList();
    }, [requestSrh]);

    useEffect(() => {
        onInputTextChange("requestStatus", "0");
    }, [requestStatusList]);

    const onGenGetRequestStatusList = () => {
        setLoading(true);
        genGetRequestStatusList(requestSrh).then(
            (res) => {
                setLoading(false);
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setRequestStatusList(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด Status Code: ${res.status}`, `${res.message}`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onGenGetRequestTypeList = () => {
        setLoading(true);
        genGetRequestTypeList(requestSrh).then(
            (res) => {
                setLoading(false);
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setRequestTypeList(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด Status Code: ${res.status}`, `${res.message}`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* <h2 className="p-m-0">ค้นหาใบแจ้งฯ</h2>
                        <hr/> */}
                        <div className="p-grid  p-fluid">
                            <div className="p-col-12 p-md-2"></div>
                            <div className="p-col-12 p-md-8">
                                <div className="p-grid  p-fluid" style={{ marginBottom: "10px" }}>
                                    <div className="p-col-12 p-md-6">
                                        <label>เลขที่ใบแจ้งฯ</label>
                                        <div className="p-inputgroup">
                                            <InputText id="contractNo" placeholder="เลขที่ใบแจ้งฯ" type="text" value={data.contractNo} onChange={(e) => onInputTextChange(e, "contractNo")} />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-grid p-fluid" style={{ marginBottom: "10px" }}>
                                    <div className="p-col-12 p-md-6">
                                        <label>สถานะใบแจ้งฯ</label>
                                        <div className="p-inputgroup">
                                            <Dropdown id="requestStatus" value={data.requestStatus} onChange={(e) => onInputTextChange(e, "requestStatus")} options={requestStatusList} optionLabel="statusTypeDesc" optionValue="statusTypeCode" placeholder="เลือก สถานะใบแจ้งฯ"></Dropdown>
                                        </div>
                                    </div>
                                    <div className="p-col-12 p-md-6">
                                        <label>ประเภทงาน</label>
                                        <div className="p-inputgroup">
                                            <Dropdown id="requestType" value={data.requestType} onChange={(e) => onInputTextChange(e, "requestType")} options={requestTypeList} optionLabel="caseTypeDesc" optionValue="caseTypeCode" placeholder="เลือก ประเภทงาน"></Dropdown>
                                        </div>
                                    </div>
                                </div>
                                <div className="p-grid p-fluid" style={{ marginBottom: "10px" }}>
                                    <div className="p-col-12 p-md-6">
                                        <label>วันที่จาก</label>
                                        <div className="p-inputgroup">
                                            <Calendars
                                                maxLength="10"
                                                key="requestDateBegin"
                                                id="requestDateBegin"
                                                placeholder="วันที่จาก"
                                                value={new Date(data.requestDateBegin)}
                                                onChange={(e) => onInputTextChange(e, "requestDateBegin")}
                                                // minDate={new Date(formObject.announce_start_date)}
                                                // onChange={(e) => setformObject({ ...formObject, announce_finish_date: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                    {/* requestDateBegin requestDateEnd */}
                                    <div className="p-col-12 p-md-6">
                                        <label>ถึงวันที่</label>
                                        <div className="p-inputgroup">
                                            <Calendars
                                                maxLength="10"
                                                key="requestDateEnd"
                                                id="requestDateEnd"
                                                placeholder="ถึงวันที่"
                                                value={new Date(data.requestDateEnd)}
                                                onChange={(e) => onInputTextChange(e, "requestDateEnd")}
                                                // minDate={new Date(formObject.announce_start_date)}
                                                // onChange={(e) => setformObject({ ...formObject, announce_finish_date: e.target.value })}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="p-grid p-fluid" style={{ marginBottom: "10px" }}>
                                    <div className="p-col-12 p-md-12">
                                        <label>คำค้นหา</label>
                                        <div className="p-inputgroup">
                                            <InputText placeholder="คำค้นหา" id="searchWord" type="text" value={data.searchWord} onChange={(e) => onInputTextChange(e, "searchWord")} />
                                        </div>
                                    </div>
                                </div>

                                <div style={{ height: "20px" }} />
                                <div className="p-grid" style={{ textAlign: "center" }}>
                                    <div className="p-col-12">
                                        <Button className="p-button" icon="pi pi-search" label="ค้นหา" style={{ width: 170, marginTop: "10px" }} onClick={() => onSearch100()} />
                                        <Button
                                            className="p-button-secondary p-button"
                                            icon="pi pi-arrow-left"
                                            label="กลับหน้าจอหลัก"
                                            // style={{ marginLeft: '5px' }}
                                            style={{ width: 170, marginLeft: "5px", marginTop: "10px" }}
                                            onClick={() => {
                                                history.push("/100");
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="p-col-12 p-md-2"></div>
                        </div>
                    </div>
                </div>
            </div>
            <DialogConfirm visible={confirmDialog} header="" modal footer={footerButtonSingle} onHide={() => setConfirmDialog(false)} textContent="กรุณาระบุเงื่อนไขในการค้นหา" />
        </>
    );
}
